import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { FeatureIstatService } from '@h5s/feature-istat';

/**
 * Angular route guard che garantisce la presenza di profili ISTAT.
 *
 */
export const featureIstatGuard: CanActivateFn = () => {
  const featureIstatService = inject(FeatureIstatService);

  return featureIstatService.checkOwnerIstatProfile();
};
